import { setDigitalData, DigitalDataMutation } from '@yme/utils/common';
export function navigationItemFromLink(link) {
    const isExternalLink = link.includes('://') && !link.startsWith(window.location.origin);
    if (isExternalLink) {
        return new URL(link).hostname + new URL(link).pathname.split('/').join('__');
    }
    const prefix = (link.split('?').shift() ?? '')
        .split('/')
        .slice(3)
        .filter((e) => e.length)
        .join('_');
    try {
        const fullLink = link.startsWith('/') ? link : `/${link}`;
        const hasProtocol = fullLink.includes('://');
        const completeLink = hasProtocol ? fullLink : `${window.location.origin}${fullLink}`;
        const allGetParamValues = Array.from(new URL(completeLink).searchParams.values())
            .map((e) => e.split('=').pop())
            .filter((el) => el !== 'true' && el !== 'false')
            .join(',');
        const suffix = allGetParamValues ? `_${allGetParamValues}` : '';
        return prefix + suffix;
    }
    catch (e) {
        return prefix;
    }
}
export function addOnClickHandler(items = []) {
    function onClick(link) {
        setDigitalData(DigitalDataMutation.NAVIGATION, {
            pageSection: 'main_menu',
            navigationGroup: '',
            navigationItem: this.link ? navigationItemFromLink(link ?? this.link) : this.pageType,
        });
    }
    return items.map((item) => {
        return {
            ...item,
            onClick: onClick.bind(item),
            childPages: addOnClickHandler(item.childPages),
            directLinks: addOnClickHandler(item.directLinks ?? []),
        };
    });
}
